import ApplicationController from "./application_controller";
import "sortable-tablesort/dist/sortable-base.min.css";
import "sortable-tablesort/dist/sortable.min.js";

export default class extends ApplicationController {
  static targets = [];

  connect() {
    console.log("connected sortable_controller.js");
    this.element.classList.add("sortable");
    this.sortby = "";
    if (this.element.dataset.sortby != undefined) {
      this.sortby = this.element.dataset.sortby;
      this.sortdir = this.element.dataset.sortdir || "ascending";
      if(this.sortdir === "ascending") {
        this.element.classList.add("asc");
      } else {
        this.element.classList.add("desc");
      }
      var xpath = "//th[text()='" + this.sortby + "']";
      var thSort = document.evaluate(
        xpath,
        document,
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null,
      ).singleNodeValue;
      if (thSort != undefined) {
        thSort.setAttribute("aria-sort", this.sortdir);
        // init sorting by simulating a click
        thSort.click();
        thSort.click();
      }
    }
  }
}
